/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { useGetTaskByUserIdAndTeamIdMutation } from "../../../../app/services/teamAPI";
import { useLazyGetTeamPlanningIdByTeamIdQuery } from "../../../../app/services/teamboardAPI";
import { decryptUrlData } from "../../../../services/CryptoService";
import { normalizeTaskGridRows } from "../../../../components/tasks/adapters/normalizeTaskGridRow";
import { getCardInfo } from "../../../../lib/getCardInfo";
import { TaskPageEnums } from "../../../../utils/Enums/TaskPageEnums";
import { useTaskFilter } from "../../../../utils/Context/TaskFilterContext";

import Toolbar from "../../../../components/tasklayout/toolbar/Toolbar";
import Viewbar from "../../../../components/tasklayout/toolbar/features/viewbar/Viewbar";
import DropDown from "../../../../components/finalForms/ui/inputs/dropdown/DropDown";
import NoDataFound from "../../../../components/ui/noDataFound/NoDataFound";
import DataLoader from "../../../../components/ui/dataLoader/DataLoader";

const applyOverviewClientFilters = (tasks, overviewFilters) => {
  if (!overviewFilters) return tasks;
  let next = tasks;

  if (overviewFilters.projectId) {
    next = next.filter((t) => Number(t.projectId) === Number(overviewFilters.projectId));
  }
  if (overviewFilters.userId != null && overviewFilters.userId !== "") {
    if (Number(overviewFilters.userId) === 0) {
      next = next.filter((t) => !t.assignedTo && !t.assigneeId && !t.userId);
    } else {
      next = next.filter(
        (t) =>
          Number(t.assignedTo) === Number(overviewFilters.userId) ||
          Number(t.assigneeId) === Number(overviewFilters.userId) ||
          Number(t.userId) === Number(overviewFilters.userId)
      );
    }
  }
  if (overviewFilters.taskStatusId) {
    next = next.filter((t) => Number(t.taskStatusId) === Number(overviewFilters.taskStatusId));
  }
  if (overviewFilters.taskCategoryId) {
    next = next.filter(
      (t) =>
        Number(t.taskTypeId) === Number(overviewFilters.taskCategoryId) ||
        Number(t.taskCategoryId) === Number(overviewFilters.taskCategoryId)
    );
  }
  if (overviewFilters.isOverdue) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    next = next.filter((t) => {
      const due = t.deadLine || t.deadline || t.dueDate;
      if (!due) return false;
      const d = new Date(due);
      d.setHours(0, 0, 0, 0);
      const statusCat = Number(t.statusCategoryId);
      const completed = statusCat === 4 || statusCat === 5;
      return d < today && !completed;
    });
  }
  if (overviewFilters.fromDate || overviewFilters.toDate) {
    const from = overviewFilters.fromDate ? new Date(overviewFilters.fromDate) : null;
    const to = overviewFilters.toDate ? new Date(overviewFilters.toDate) : null;
    if (from) from.setHours(0, 0, 0, 0);
    if (to) to.setHours(23, 59, 59, 999);
    next = next.filter((t) => {
      const due = t.deadLine || t.deadline || t.dueDate;
      if (!due) return true;
      const d = new Date(due);
      if (from && d < from) return false;
      if (to && d > to) return false;
      return true;
    });
  }

  return next;
};

const MyTeamTask = () => {
  const { id } = useParams();
  const location = useLocation();
  const overviewFilters = location.state?.fromTeamOverview
    ? location.state.overviewFilters
    : null;

  let TeamId = null;
  let teamname = "";
  const teamIdData = id ? decryptUrlData(id) : 0;
  if (typeof teamIdData === "object" && teamIdData !== null) {
    TeamId = teamIdData.teamId;
    teamname = teamIdData.teamName;
  } else if (teamIdData) {
    TeamId = teamIdData;
  }

  const [planningId, setPlanningId] = useState(null);
  const [planningOptions, setPlanningOptions] = useState([]);
  const [taskdata, setTaskdata] = useState([]);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [drilldownApplied, setDrilldownApplied] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const userId = user.userId;
  const { filterRequest, resetFilters } = useTaskFilter();

  const [getTaskByUserIdAndTeamId, {
    isLoading: isgetTaskByUserIdAndTeamIdLoading,
    isFetching: isgetTaskByUserIdAndTeamIdFetching,
    isSuccess: isgetTaskByUserIdAndTeamIdSuccess,
    data: isgetTaskByUserIdAndTeamIdData,
  }] = useGetTaskByUserIdAndTeamIdMutation();

  const [getTeamPlanningIdByTeamId, {
    isLoading: isTeamPlannningListLoading,
    isFetching: isTeamPlannningListFetching,
    isSuccess: isTeamPlannningListSuccess,
    data: isTeamPlannningListData,
  }] = useLazyGetTeamPlanningIdByTeamIdQuery();

  useEffect(() => {
    if (TeamId) {
      getTeamPlanningIdByTeamId(TeamId);
    }
  }, [TeamId]);

  useEffect(() => {
    if (!isTeamPlannningListFetching && isTeamPlannningListSuccess && isTeamPlannningListData) {
      const source = isTeamPlannningListData.dataSource || [];
      setPlanningOptions(
        source.map((item) => ({
          value: item.teamPlanningId,
          label: item.startDate,
        }))
      );
      const drillPlanning = overviewFilters?.planningId;
      if (!drilldownApplied && drillPlanning) {
        setPlanningId(drillPlanning);
        setDrilldownApplied(true);
      } else if (planningId == null) {
        setPlanningId(isTeamPlannningListData.teamPlanningId);
      }
    }
  }, [isTeamPlannningListSuccess, isTeamPlannningListData, isTeamPlannningListFetching, overviewFilters, drilldownApplied, planningId]);

  const GetTaskList = () => {
    getTaskByUserIdAndTeamId({
      userId: overviewFilters?.userId && Number(overviewFilters.userId) !== 0
        ? overviewFilters.userId
        : 0,
      planningId: planningId || 0,
      TeamId,
      CurrentDate: new Date(),
      filterData: JSON.stringify(filterRequest || []),
    });
  };

  useEffect(() => {
    if (TeamId && userId && planningId != null) {
      GetTaskList();
    }
  }, [planningId, TeamId, userId, filterRequest]);

  useEffect(() => {
    if (!isgetTaskByUserIdAndTeamIdFetching && isgetTaskByUserIdAndTeamIdSuccess && isgetTaskByUserIdAndTeamIdData) {
      setHasLoadedOnce(true);
      const normalized = normalizeTaskGridRows(isgetTaskByUserIdAndTeamIdData);
      setTaskdata(applyOverviewClientFilters(normalized, overviewFilters));
    }
  }, [
    isgetTaskByUserIdAndTeamIdFetching,
    isgetTaskByUserIdAndTeamIdSuccess,
    isgetTaskByUserIdAndTeamIdData,
    overviewFilters,
  ]);

  const handleRefreshGrid = () => GetTaskList();

  const filteredTasks = searchText
    ? taskdata.filter((task) => {
        const needle = searchText.toLowerCase();
        return (
          String(task.taskId ?? "").toLowerCase().includes(needle) ||
          String(task.title ?? "").toLowerCase().includes(needle)
        );
      })
    : taskdata;

  const cardData = [{ key: "Team Name", value: teamname }];
  const projectIdFromTasks = filteredTasks[0]?.projectId || overviewFilters?.projectId || 0;
  const isInitialLoad = isgetTaskByUserIdAndTeamIdLoading && !hasLoadedOnce;
  const hasActiveFilters = (filterRequest || []).length > 0;

  if (isTeamPlannningListLoading && !hasLoadedOnce) {
    return <DataLoader />;
  }

  return (
    <div className="myteam-tasklist center-top-space">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
        {cardData ? getCardInfo(cardData) : null}
        {planningOptions.length > 0 && (
          <div className="task-grid-dropdown" style={{ minWidth: 220 }}>
            <DropDown
              title="Planning"
              type="dropdown"
              options={planningOptions}
              value={planningId}
              placeholder="Select Planning"
              isSearchable={false}
              onChange={(option) =>
                setPlanningId(typeof option === "object" ? option?.value : option)
              }
            />
          </div>
        )}
      </div>
      {overviewFilters ? (
        <div className="mb-2" style={{ fontSize: 12, color: "#64748b" }}>
          Filtered from Team Overview
          {overviewFilters.isOverdue ? " · Overdue" : ""}
          {overviewFilters.projectId ? ` · Project #${overviewFilters.projectId}` : ""}
        </div>
      ) : null}
      <div className="task-layout">
        <Viewbar
          projectId={projectIdFromTasks}
          showCompleted={false}
          onToggleChange={() => {}}
          onSearchChange={setSearchText}
          taskFilterPageId={TaskPageEnums.MY_TEAM_TASK}
        />
        <div className="task-layout-toolbar">
          {filteredTasks.length > 0 || isInitialLoad ? (
            <Toolbar
              listOnly
              projectId={projectIdFromTasks}
              taskListData={filteredTasks}
              isTeamPlanning={false}
              allowEditStatus={Boolean(projectIdFromTasks)}
              allowEditAssignee={false}
              isShowActualTime={false}
              isShowRemainingTime={true}
              isDataLoading={isInitialLoad}
              isRefreshing={isgetTaskByUserIdAndTeamIdFetching && hasLoadedOnce}
              onRefreshGrid={handleRefreshGrid}
              onClearFilters={resetFilters}
              hasActiveFilters={hasActiveFilters}
              hasActiveSearch={Boolean(searchText)}
            />
          ) : (
            <NoDataFound />
          )}
        </div>
      </div>
    </div>
  );
};

export default MyTeamTask;
